import { PopUpManager, WizPopUp } from '@wizeoo/akm-component-lib';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { ZoomPop, zoomPopParams } from '../../../components/widgets/freedatas/renderers/zoom.pop';

// méthodes utilitaires sur base numérique
export class PopUtils {
  /**
   * position d'une pop en fonction d'un point de coord.
   * @param initPoint DOMRect, l'origine de la demande
   * @param popUp la pop
   * @param preferedPos éventuelle préférence
   * @returns [x,y]
   */
  public static setPopCoord(
    initPoint: { x: number; y: number },
    popUp: WizPopUp,
    preferedPos?: WIZ_PHYSIC_POSITION
  ): [number, number] {
    let result: [number, number] = [0, 0];

    const popWidth: number = Number(popUp.width.replace('px', '').replace('%', ''));
    const popHeight: number = Number(popUp.height.replace('px', '').replace('%', ''));

    // TODO prendre en compte le scroll...
    const totalWidth: number = window.innerWidth;
    const totalHeight: number = window.innerHeight;
    const leftSpace: number = initPoint.x;
    const topSpace: number = initPoint.y;
    const rightSpace: number = totalWidth - initPoint.x;
    const bottomSpace: number = totalHeight - initPoint.y;

    // TOP_LEFT = 0,
    // TOP_RIGHT = 1,
    // BOTTOM_LEFT = 2,
    // BOTTOM_RIGHT = 3,
    const availables: [number, [number, number]][] = [];
    if (leftSpace >= popWidth && topSpace >= popHeight) {
      availables.push([WIZ_PHYSIC_POSITION.TOP_LEFT, [leftSpace - popWidth, topSpace - popHeight]]);
    }
    if (rightSpace >= popWidth && topSpace >= popHeight) {
      availables.push([WIZ_PHYSIC_POSITION.TOP_RIGHT, [leftSpace, topSpace - popHeight]]);
    }
    if (leftSpace >= popWidth && bottomSpace >= popHeight) {
      availables.push([WIZ_PHYSIC_POSITION.BOTTOM_LEFT, [leftSpace - popWidth, topSpace]]);
    }
    if (rightSpace >= popWidth && bottomSpace >= popHeight) {
      availables.push([WIZ_PHYSIC_POSITION.BOTTOM_RIGHT, [leftSpace, topSpace]]);
    }

    if (availables.length > 0) {
      result = availables[0][1];
      if (preferedPos) {
        availables.forEach((item) => {
          if (item[0] === preferedPos) {
            result = item[1];
          }
        });
      }
    }
    return result;
  }

  /**
   * zoom sur une image
   */
  public static showZoomPop(params: zoomPopParams): void {
    // e.stopImmediatePropagation();
    // e.preventDefault();

    if (PopUpManager.exist(params.zoomPop)) {
      // suppression de l'instance existante
      params.zoomPop.hide();
    }

    let popFactory: any = ZoomPop;

    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    params.zoomPop = new WizPopUp(
      popFactory,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '95%',
      '95%'
    );

  
    // alimentation des datas
    params.zoomPop.datas = params;
    params.zoomPop.show();
  }



}
